import React from 'react';
import { AppPage } from '../components/appPage';

const SplashScreen: React.FC = () => {
  return (
    <AppPage
      className="app--bgBlack"
      content={
        <img
          src="/assets/werewolf-logo.svg"
          alt="Werewolf Logo"
          className="w-full max-w-[600px] animate-fade-in"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      }
    />
  );
};

export default SplashScreen;
